import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './api_slice';
import rootReducer from './reducers';

const store = configureStore({
  reducer: {
    ...rootReducer,
    [apiSlice.reducerPath]: apiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

window.ecom.redux_store = store;

export default store;

export const getMockStore = (preloadedState) =>
  configureStore({
    reducer: {
      ...rootReducer,
      [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(apiSlice.middleware),
    preloadedState,
  });
